import { PropTypes } from 'react';

export const width = PropTypes.number.isRequired;
export const height = PropTypes.number.isRequired;
export const listWidth = PropTypes.number.isRequired;
export const lists = PropTypes.array;
export const itemComponent = PropTypes.func;
export const listComponent = PropTypes.func;
export const itemPreviewComponent = PropTypes.func;
export const listPreviewComponent = PropTypes.func;
export const onMoveRow = PropTypes.func;
export const onMoveList = PropTypes.func;
export const onDropRow = PropTypes.func;
export const onDropList = PropTypes.func;
export const onDragBeginRow = PropTypes.func;
export const onDragBeginList = PropTypes.func;
export const onDragEndRow = PropTypes.func;
export const onDragEndList = PropTypes.func;
export const overscanListCount = PropTypes.number;
export const overscanRowCount = PropTypes.number;
export const scrollToList = PropTypes.number;
export const scrollToAlignment = PropTypes.string;
export const itemCacheKey = PropTypes.func;



/** WEBPACK FOOTER **
 ** ./src/Kanban/propTypes.js
 **/